module.exports = __webpack_public_path__ + "img/112045.16320af3.png";